import { React, useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import ShareClassOverview from "../components/ShareClassOverview";
import OrientationPrompt from "../components/OrientationPrompt";
import {
  getClass,
  getClasses,
  getIndividualSchool,
  getTeachers,
  whoami,
} from "../services/APIClient";

function ShareClass(props) {
  const location = useLocation();
  const [shareState, setShareState] = useState(location.state || null);
  const [error, setError] = useState("");

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);
  // console.log(rollNumber)
  // console.log(teacherEmail)

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    if (location.state) {
      setShareState(location.state);
      setError("");
      return;
    }

    setShareState(null);

    const queryParams = new URLSearchParams(location.search);
    const classid = queryParams.get("classid");
    const requestedTeacherId = queryParams.get("teacherid");
    const requestId = (
      queryParams.get("requestid") || queryParams.get("requestId")
    )?.trim();

    if (!classid) {
      setError("This class sharing link is missing a class ID.");
      return;
    }

    let isMounted = true;

    async function hydrateShareClassState() {
      setError("");

      try {
        const [whoamiResponse, accessibleClasses] = await Promise.all([
          whoami(),
          getClasses(),
        ]);
        const stakeholder = whoamiResponse.data?.stakeholder || {};
        const schoolid = stakeholder.schoolid;

        if (!schoolid) {
          throw new Error("Unable to identify the current teacher's school.");
        }

        if (!isMounted) {
          return;
        }

        const hasClassAccess = accessibleClasses.some(
          (classDetails) => classDetails.id === classid
        );

        if (!hasClassAccess) {
          setError(
            "You no longer have access to this class, so it can't be shared from this link."
          );
          return;
        }

        const [classDetails, teachers, schoolDetails] = await Promise.all([
          getClass(classid),
          getTeachers(),
          getIndividualSchool(schoolid).catch(() => null),
        ]);

        if (!isMounted) {
          return;
        }

        setShareState({
          classDetails: { classDetails },
          teachers: { teachers },
          sharedWith: { sharedWith: classDetails.sharedWith || [] },
          name: { name: stakeholder.name || "" },
          gradeLevel: { gradeLevel: classDetails.grade_level },
          rollNumber: {
            rollNumber: schoolDetails?.rollnumber || schoolDetails?.rollNumber,
          },
          teacherEmail: { teacherEmail: stakeholder.email || "" },
          schoolid: { schoolid },
          requestedTeacherId,
          requestId,
        });
      } catch (err) {
        console.error("Error loading class sharing link:", err);

        if (!isMounted) {
          return;
        }

        setError(
          "We couldn't load this class sharing link. Please check that the class exists and that you have access to share it."
        );
      }
    }

    hydrateShareClassState();

    return () => {
      isMounted = false;
    };
  }, [location.search, location.state]);

  let name = shareState?.name?.name || "";
  let rollNumber = shareState?.rollNumber?.rollNumber;
  let teacherEmail = shareState?.teacherEmail?.teacherEmail;
  let teacherid = shareState?.classDetails?.classDetails?.teacherId;
  let schoolid = shareState?.schoolid?.schoolid;

  const renderContent = () => {
    if (!shareState && !error) {
      return (
        <div className="spinner-container">
          <div className="big-ball-spinner"></div>
        </div>
      );
    }

    if (error || !shareState) {
      return (
        <div className="class-overview-container">
          <Container className="container-shape">
            <Row className="page-description-bar">
              <Col>
                <h2 className="page-description-header">Share Class</h2>
                <p>{error || "This class sharing link could not be loaded."}</p>
                <Link to="/classadmindashboard">
                  <button className="light-blue-button">Back to Classes</button>
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return (
      <ShareClassOverview
        classDetails={shareState.classDetails}
        teachers={shareState.teachers}
        sharedWith={shareState.sharedWith}
        // classDetails={specificClass}
        gradeLevel={shareState.gradeLevel.gradeLevel}
        name={shareState.name.name}
        rollNumber={rollNumber}
        teacherEmail={teacherEmail}
        schoolid={schoolid}
        requestedTeacherId={shareState.requestedTeacherId}
        requestId={shareState.requestId}
      />
    );
  };

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        isLoggedIn={true}
        cloud={true}
        name={name}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          {renderContent()}
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default ShareClass;
